import { Decimal } from "decimal.js";

const BillUnit = 10000;

// 获取百分比的格式，num1分子，num2分母，pointNum小数点保留位数
export const getPercentFormat = (num1, num2, pointNum = 3) => {
	if (num2) {
		// 保留两位小数
		const formatNum = ((num1 / num2) * 100).toFixed(pointNum);
		return formatNum + "%";
	}
	return (0).toFixed(pointNum) + "%";
};

// 运营平台统一除以 10000 后，以美元显示
export const formatBillUnit = (bill, pointNum = 6) => {
  return Decimal.div(bill || 0, BillUnit).toFixed(pointNum);
};

// 获取数值千分位表现形式
export function getSthousandsFormatNum(num) {
	return (num + "").replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
}

// 通过OrganizationId获取项目名称：公司-项目
export function renderAccountCNameByOrgId(customerList, OrganizationId) {
	const customer = customerList.find(item => item.OrganizationId === OrganizationId);
	return customer ? `${customer.CompanyName} - ${customer.OrganizationName} - ${customer.Remark}` : OrganizationId;
}

// 通过OrganizationId获取CompanyId
export function getCompanyIdByOrgId(customerList, OrganizationId) {
	const customer = customerList.find(item => item.OrganizationId === OrganizationId);
	return customer ? customer.CompanyId : null;
}

// 通过BrevityCode获取国家名称：[英文]中文
export function renderCountryCNameByBrevityCode(code, countryList) {
	const country = countryList.find(item => item.BrevityCode === code);
	return country ? `[${code}]${country.NameCn}` : code === "EN" ? "[EN]全部" : code;
}

// 通过ChannelId获取通道名称：中文-英文
export function renderChannelCNameByChannelId(channelId, channelList) {
  const channel = channelList.find((item) => item.ChannelId === channelId);
  return channel ? `[${channelId}]${channel.ChannelName}` : channelId;
}


// 数组按照字段去重
export function uniqueArrByKey(list, key, orderKey) {
	const res = new Map();
	return list
		.filter(item => !res.has(item[key]) && res.set(item[key], true))
		.sort((a, b) => a[orderKey] - b[orderKey]);
}

// 按照给定的key聚合 group by
export const arrayGroupByObjectKey = (list, key) => {
	const result = {};
	if (list && list.length > 0) {
		list.forEach(item => {
			const existed = result[item[key]];
			if (existed && existed.length > 0) {
				result[item[key]].push(item);
			} else {
				result[item[key]] = [item];
			}
		});
	}

	return result;
};

// 两数组比较, 满足judgeFunc的数据拿出来存在第三个数组里
export const replaceArray = (former = [], latter = [], judgeFunc) => {
	const showList = [];
	for (let i = 0; i < former.length; i++) {
		for (let j = 0; j < latter.length; j++) {
			if (judgeFunc(i, j)) {
				showList.push(former[i]);
				former.splice(i, 1);
				i--;
			}
		}
	}

	return showList;
};

// 有效数组校验
export function isValidArray(array) {
	return Array.prototype.isPrototypeOf(array) && array.length > 0;
}

// 有效对象校验
export function isValidObject(obj) {
	return Object.prototype.isPrototypeOf(obj) && Object.keys(obj).length > 0;
}

// 删除数组中某个元素
export function ArrRemoveItem(arr, item) {
	let index = arr.indexOf(item);
	if (index > -1) {
		arr.splice(index, 1);
	}
	return arr;
}

export function JSONParse(data) {
	if (!data) return undefined;
	try {
		return JSON.parse(data);
	} catch (err) {
		return undefined;
	}
}
// 海外站接口返回数据为元的10000倍，展示数据需要除以10000，传递值需要乘以10000
export const formatAmount = value => {
	if (!value || isNaN(value)) return 0;
	return Decimal.mul(value, 10000).toNumber();
};

// 从一个列表中查找某条数据，返回想要的值，像通过用户id获取用户名称
export const getNameByOrtherKey = (list, inKey, inValue, outKey, renderItem) => {
	const field = list.find(item => item[inKey] === inValue);
	return field ? (renderItem ? renderItem(field) : field[outKey]) : inValue;
};

export const calculateBillUnit = bill => {
	return Decimal.div(bill, 10000).toNumber();
};

// price 应为用户输入的元，不带10000的格式化
export const calculateDiscountWithPrice = (price, originPrice) => {
	return Decimal.div(price, originPrice).toFixed(6);
};

export const PriceDivide = (price, originPrice) => {
	return +Decimal.div(price, originPrice).toFixed(6);
};

// 防抖
export function debounce(cb, wait = 3000) {
  let timer = null;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      cb.apply(this, args);
    }, wait);
  };
}